import Button from '@mui/joy/Button'
import Box from '@mui/joy/Box'
import IconButton from '@mui/joy/IconButton'
import { FilePickerButton } from './ui/FilePickerButton'
import SquareOutlined from '@mui/icons-material/SquareOutlined'
import ChangeHistoryOutlined from '@mui/icons-material/ChangeHistoryOutlined'
import CircleOutlined from '@mui/icons-material/CircleOutlined'
import TitleOutlined from '@mui/icons-material/TitleOutlined'

export const ButtonPanel = ({
    onRectClick,
    onCircleClick,
    onTriangleClick,
    onTextboxClick,
    onFileChange,
}) => {
    return (
        <>
            <Button
                onClick={onRectClick}
                color="neutral"
                variant="outlined"
                startDecorator={<SquareOutlined />}
            >
                <Box sx={{ flex: 1 }}>Square</Box>
            </Button>
            <Button
                onClick={onCircleClick}
                color="neutral"
                variant="outlined"
                startDecorator={<CircleOutlined />}
            >
                <Box sx={{ flex: 1 }}>Circle</Box>
            </Button>
            <Button
                onClick={onTriangleClick}
                color="neutral"
                variant="outlined"
                startDecorator={<ChangeHistoryOutlined />}
            >
                <Box sx={{ flex: 1 }}>Triangle</Box>
            </Button>
            <Button
                onClick={onTextboxClick}
                color="neutral"
                variant="outlined"
                startDecorator={<TitleOutlined />}
            >
                <Box sx={{ flex: 1 }}>Text</Box>
            </Button>
            <FilePickerButton onFileChange={onFileChange} />
        </>
    )
}
